// extracted by mini-css-extract-plugin
export default {"wrapper":"base-page_wrapper__b7Mmf","innerWrapper":"base-page_innerWrapper__pVcRB","title":"base-page_title__SOlU8","loaderWrapper":"base-page_loaderWrapper__aBYqQ"};